'use client';
import { useEffect } from 'react';
import { isDevelopment } from '@/shared/config/brand-by-target.mjs';

const ServiceWorkerRegistrar = () => {
  useEffect(() => {
    if (isDevelopment || !('serviceWorker' in navigator)) return;

    const register = () => {
      const params = new URLSearchParams({
        target: process.env.NEXT_PUBLIC_TARGET ?? '',
        hostname: process.env.NEXT_PUBLIC_HOSTNAME ?? '',
      });

      navigator.serviceWorker
        .register(`/sw.js?${params}`, { scope: '/' })
        .catch((error) => {
          console.warn('Service worker registration failed', error);
        });
    };

    if (document.readyState === 'complete') {
      register();
      return;
    }

    window.addEventListener('load', register, { once: true });

    return () => {
      window.removeEventListener('load', register);
    };
  }, []);

  return null;
};

export { ServiceWorkerRegistrar };
